import { useState, Fragment, useEffect } from "react";
import { Grid } from "@material-ui/core";
import { mongoDBDateParserToUSAFormat } from "../../../../../../utils/commonFunctions/date";

import "./ksopParticipantSignature.css";
/* eslint-disable */

const KsopPartcipantSignature = (props) => {
	// console.log("KsopPartcipantSignature Props====", props?.employeeDetails);
	return (
		<div className="ksop-participant-signature">
			<div className="ksop-block">
				<div className="side-box">Must Sign</div>
				<div className="content-box-gray">
					<div className="title">Participant Signature</div>

					<div className={"content " + (props.isPrintable ? "font-size-12" : "font-size-14")}>
						<b style={{ paddingLeft: "5px" }}>
							This designation revokes all prior designations made under the plan.
						</b>
						<Grid container spacing={0}>
							<Grid item xs={4} className="inside-item-border3">
								<mark>Participant Signature (Required)</mark>
								<p>{props?.employeeDetails?.first_name + " " + props?.employeeDetails?.last_name}</p>
							</Grid>
							<Grid item xs={4} className="inside-item-border3">
								<mark>Date</mark>
								<p>
									{props?.enrollments?.enrollment_date
										? mongoDBDateParserToUSAFormat(props?.enrollments?.enrollment_date)
										: props?.enrollments?.enrollment_date}
								</p>
							</Grid>
							<Grid item xs={4} className="inside-item-border3">
								Received and filed by Principal Life Ins. Co.
								<p>
									<b>Date Received</b>
									<input
										className="input-bottom-border"
										type="text"
										placeholder="MM/DD/YYYY"
										disabled
									></input>
								</p>
							</Grid>
						</Grid>
						<p style={{ paddingLeft: "5px" }}>
							UNDER THE PENALTIES OF PERJURY, I certify by my signature that all of the information on
							this Beneficiary Designation form is true, current, and complete.
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default KsopPartcipantSignature;
